export const clientValidationRules = (values) => {
  const errors = {};
  const phoneRegex = /^\+[1-9]\d{0,3}\d{6,11}$/;

  if (!values.name) errors.name = "Name is required";
  else if (values.name.length < 3) errors.name = "Name must be at least 3 characters";
  if (!values.primaryPhone) errors.primaryPhone = "Mobile number is required";
  else if (!phoneRegex.test(values.primaryPhone)) errors.primaryPhone = "Enter valid number (with country code)";

  return errors;
};

export const receivablesValidationRules = (clientId, values) => {
  const errors = {};

  if (!clientId) errors.clientId = "Please select a client";
  if (!values.projectId) errors.projectId = "Please select a project";
  if (!values.date) errors.date = "Please select a date";
  if (!values.amount) errors.amount = "Amount is required";
  else if (values.amount < 1) errors.amount = "Amount must be greater than 0";
  else if (values.amount && !/^\d+(\.\d{1,2})?$/.test(values.amount.toString()))
    errors.amount = "At most 2 decimal places are allowed";

  return errors;
};

export const incomeValidationRules = (values) => {
  const errors = {};

  if (!values.sourceId) errors.sourceId = "Please select client";
  if (!values.projectId) errors.projectId = "Please select project";
  if (!values.date) errors.date = "Please select a date";
  if (!values.amount) errors.amount = "Amount is required";
  else if (values.amount < 1) errors.amount = "Amount must be greater than 0";
  else if (values.amount && !/^\d+(\.\d{1,2})?$/.test(values.amount.toString()))
    errors.amount = "At most 2 decimal places are allowed";
  if (!values.incomeId && !values.toAccountId) errors.toAccountId = "Please select an account";

  return errors;
};

export const invoiceValidationRules = (clientId, projectId, values) => {
  const errors = {};

  if (!clientId) errors.clientId = "Please select a client";
  if (!projectId) errors.projectId = "Please select a project";
  if (!values.date) errors.date = "Please select a date";
  if (!values.amount) errors.amount = "Amount is required";
  else if (values.amount < 1) errors.amount = "Amount must be greater than 0";
  else if (values.amount && !/^\d+(\.\d{1,2})?$/.test(values.amount.toString()))
    errors.amount = "At most 2 decimal places are allowed";

  return errors;
};
